import { IconType } from 'components/Icon';
import ActionButton from 'components/Widget/ActionButton';
import { DS_TAB_CHROME, sectionToTabTarget } from 'designSystem/util';
import { pathsToDsLinks } from 'designSystem/content/util';
import { DsSection, DsTabKind, VALID_DS_SECTIONS } from 'designSystem/types';
import useDsNavigation from 'hooks/useDsNavigation';

// Mirrors how DsUpdateCard resolves its paths. Translates the chat-side section
// (file-group) prefix on a path into the UI tab to open.
function resolveShowPath(
	path?: string
): { kind: DsTabKind; contentPath?: string; label: string } | null {
	if (!path) return null;
	const sectionPrefix = path.split('/')[0];
	if (!(VALID_DS_SECTIONS as readonly string[]).includes(sectionPrefix)) return null;
	const section = sectionPrefix as DsSection;
	const links = pathsToDsLinks([path], section);
	const link = links[0];
	if (!link || link.deleted) return null;

	const target = sectionToTabTarget(section, link.contentPath);
	return { kind: target.kind, contentPath: target.contentPath, label: link.label };
}

interface Props {
	path?: string;
}

const ShowAction = ({ path }: Props) => {
	const { openTab } = useDsNavigation();
	const target = resolveShowPath(path);

	const chrome = target ? DS_TAB_CHROME[target.kind] : null;
	const icon = chrome?.icon ?? IconType.FRAME;
	const label = target ? `View ${target.label}` : 'Open in design system';

	const onClick = () => {
		if (target) openTab(target.kind, target.contentPath);
	};

	return <ActionButton icon={icon} label={label} onClick={onClick} />;
};

export default ShowAction;
